<template>
  <el-scrollbar style="width: 100%;height: 100%;overflow:auto;">
    <el-form label-width="150px" style="margin-top: 10px;">
      <el-row>
        <el-col :span="11">
          <el-form-item label="年度" required>
            <el-select v-model="year" placeholder="请选择年度" @change="getYearKpiList">
              <el-option v-for="item in yearList" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="11">
          <el-form-item label="公司" required>
            <el-select v-model="company" placeholder="请选择公司" @change="getTeamList">
              <el-option v-for="item in companyList" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="11">
          <el-form-item label="团队" required>
            <el-select v-model="team" placeholder="请选择团队">
              <el-option v-for="item in teamList" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <div style="margin:0 0 10px 10px;">基本KPI：</div>
    <div style="display: flex;line-height: 30px;text-align: center;background-color: #cccccc;margin: 0 10px 0 10px;">
      <div style="width: 50px">序号</div>
      <div style="width: 100px">KPI开关</div>
      <div style="flex: 1;">任务名称</div>
      <div style="width: 150px">基本任务-销量(套)</div>
      <div style="width: 150px">基本任务-销售额(￥)</div>
      <div style="width: 150px">SS续约率(%)</div>
    </div>
    <div style="margin: 0 10px 0 10px; min-height: 100px;">
      <div v-for="(item,index) in basicKpiNameList" style="display: flex;text-align: center;margin-top: 10px">
        <div style="width: 50px">{{ index + 1 }}</div>
        <div style="width: 100px">
          <el-checkbox v-model="item.kpi_switch" label=" " :value="true" :checked="true"/>
        </div>
        <div style="flex: 1;">{{ item.kpi_name }}</div>
        <div style="width: 150px">
          <el-input-number style="padding: 0 5px 0 5px;" v-model="item.basic_sales" min="0" :controls="false" @change="computeBasicSales"></el-input-number>
        </div>
        <div style="width: 150px">
          <el-input-number style="padding: 0 5px 0 5px;" v-model="item.basic_price" min="0" :controls="false" :precision="2" @change="computeBasicPrice"></el-input-number>
        </div>
        <div style="width: 150px">
          <el-input-number style="padding: 0 5px 0 5px;" v-model="item.basic_renewal_contract" min="0" :controls="false"></el-input-number>
        </div>
      </div>
    </div>
    <div style="display: flex;line-height: 30px;text-align: center;background-color: #cccccc;margin: 10px 10px 0 10px;">
      <div style="flex: 1;">合计</div>
      <div style="width: 150px">{{ basicSalesSum }}</div>
      <div style="width: 150px">{{ basicPriceSum }}</div>
      <div style="width: 150px">-</div>
    </div>

    <div style="margin:10px 0 10px 10px;">高级KPI：</div>
    <div style="display: flex;line-height: 30px;text-align: center;background-color: #cccccc;margin: 0 10px 0 10px;">
      <div style="width: 50px">序号</div>
      <div style="width: 100px">KPI开关</div>
      <div style="flex: 1;">任务名称</div>
      <div style="width: 150px">基本任务-销量(套)</div>
      <div style="width: 150px">基本任务-销售额(￥)</div>
      <div style="width: 150px">SS续约率(%)</div>
    </div>
    <div style="margin: 0 10px 0 10px;min-height: 100px;">
      <div v-for="(item,index) in highKpiNameList" style="display: flex;text-align: center;margin-top: 10px">
        <div style="width: 50px">{{ index + 1 }}</div>
        <div style="width: 100px">
          <el-checkbox v-model="item.kpi_switch" label=" " :value="true" :checked="true"/>
        </div>
        <div style="flex: 1;">{{ item.kpi_name }}</div>
        <div style="width: 150px">
          <el-input-number style="padding: 0 5px 0 5px;" v-model="item.high_sales" min="0" :controls="false" @change="computeHighSales"></el-input-number>
        </div>
        <div style="width: 150px">
          <el-input-number style="padding: 0 5px 0 5px;" v-model="item.high_price" min="0" :controls="false" :precision="2" @change="computeHighPrice"></el-input-number>
        </div>
        <div style="width: 150px">
          <el-input-number style="padding: 0 5px 0 5px;" v-model="item.high_renewal_contract" min="0" :controls="false"></el-input-number>
        </div>
      </div>
    </div>
    <div style="display: flex;line-height: 30px;text-align: center;background-color: #cccccc;margin: 10px 10px 0 10px;">
      <div style="flex: 1;">合计</div>
      <div style="width: 150px">{{ highSalesSum }}</div>
      <div style="width: 150px">{{ highPriceSum }}</div>
      <div style="width: 150px">-</div>
    </div>

    <div style="width: 100%; text-align: center;margin-top: 20px;margin-bottom: 20px;">
      <el-button type="primary" style="width: 100px" @click="editYearKpi" >保存</el-button>
    </div>





  </el-scrollbar>

</template>

<script>
export default {
  name: "EditYearKpi",
  inject: ['$fn'],
  props: {
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },

  data(){
    return {
      year:'',
      company:'',
      team:'',
      companyList:[],
      yearList:[],
      teamList:[],
      basicKpiNameList:[],
      highKpiNameList:[],
      basicSalesSum:0,
      basicPriceSum:0,
      highSalesSum:0,
      highPriceSum:0,
    }

  },
  computed: {

  },
  created() {
    this.initData();


  },
  mounted() {

  },

  methods:{
    async initData(){
      this.year = this.parentData.year;
      this.company = this.parentData.company;
      this.team = this.parentData.team;
      this.basicPriceSum = this.parentData.basic_price_sum;
      this.basicSalesSum = this.parentData.basic_sales_sum;
      this.highPriceSum = this.parentData.high_price_sum;
      this.highSalesSum = this.parentData.high_sales_sum;
      await this.getYearList();
      await this.getCompanyList();
      await this.getTeamList();
      await this.getYearKpiList();
    },
    async computeBasicSales(){
      let sum = 0;
      this.basicKpiNameList.forEach(item => {
        sum = sum + item.basic_sales;
      })
      this.basicSalesSum = sum;
    },
    async computeBasicPrice(){
      let sum = 0;
      this.basicKpiNameList.forEach(item => {
        sum = sum + item.basic_price;
      })
      this.basicPriceSum = sum;
    },

    async computeHighSales(){
      let sum = 0;
      this.highKpiNameList.forEach(item => {
        sum = sum + item.high_sales;
      })
      this.highSalesSum = sum;
    },
    async computeHighPrice(){
      let sum = 0;
      this.highKpiNameList.forEach(item => {
        sum = sum + item.high_price;
      })
      this.highPriceSum = sum;
    },

    async getYearList(){
      this.yearList = await this.$http('crmCompanyKpiService.getProductSkuYear');
    },
    async getCompanyList(){
      this.companyList = await this.$http('crmTeamService.getCompanyList');
    },
    //保存年度kpi
    editYearKpi(){
      if(!this.year){
        this.$message.error("请选择年度");
      }
      if(!this.company){
        this.$message.error("请选择公司");
      }
      let params = {basicKpiList:this.basicKpiNameList,
        highKpiList:this.highKpiNameList,
        year:this.year,
        company:this.company,
        team:this.team}
      this.$http('crmCompanyKpiService.editYearKpi',params).then(() => {
        this.$fn.closeWindow();
        this.$fn.search();
        this.$message.success("保存成功");
      });
    },
    //获取kpi项目数据
    async getYearKpiList(){
      let params = {year:this.year,company:this.company,team:this.team}
      let data = await this.$http('crmCompanyKpiService.getKpiByYearAndCompanyOrTeam',params)
      this.basicKpiNameList = data;
      this.highKpiNameList = data;
    },
    //根据公司选择团队数据
    async getTeamList(){
      let params = {company:this.company}
      this.teamList = await this.$http('crmTeamService.getTeamByCompany',params);
    },

  }
}
</script>

<style scoped>

</style>